import { render, staticRenderFns } from "./TripPreview.vue?vue&type=template&id=f4db34b8&"
import script from "./TripPreview.vue?vue&type=script&lang=js&"
export * from "./TripPreview.vue?vue&type=script&lang=js&"
import style0 from "./TripPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TripPreview.vue"
export default component.exports